import { useQuery } from '@tanstack/react-query'
import { ListDistributionsDocument } from '@vendia/control-plane-api'
import { useRecoilValue } from 'recoil'

import { selectedRoleState } from '../state'
import useControlPlaneApi from './use-control-plane-api'

const QUERY_KEY = 'listConsumerDistros'

export function useListConsumerDistributions({ isAuthenticated = true } = {}) {
  const client = useControlPlaneApi()
  const selectedRoleName = useRecoilValue(selectedRoleState).name
  return useQuery({
    queryKey: [QUERY_KEY, selectedRoleName],
    queryFn: () => client.graphqlFetch({ query: ListDistributionsDocument }),
    enabled: isAuthenticated && !!selectedRoleName,
  })
}
